/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReactionButtonContainer_viewer = {
    readonly id: string;
    readonly " $refType": "ReactionButtonContainer_viewer";
};
export type ReactionButtonContainer_viewer$data = ReactionButtonContainer_viewer;
export type ReactionButtonContainer_viewer$key = {
    readonly " $data"?: ReactionButtonContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReactionButtonContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReactionButtonContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '8743aee4ecd74571a4acd517fdc699ae';
export default node;
